import React, { Fragment } from "react";
import Navbar from "../components/Navbar";
import Landing from "../components/Landing";
import FirstFourEpisodes from "./FirstFourEpisodes";
import StoreCTA from "../components/StoreCTA";

const Hero = () => {
  return (
    <Fragment>
      <div className="bg-cream px-8 py-12 md:px-16 md:py-24">
        <Navbar />
        <Landing />
      </div>
      <div className="px-4 py-12 flex justify-between">
        <FirstFourEpisodes />
      </div>
      <StoreCTA />
    </Fragment>
  );
};

export default Hero;
